<template>
    <el-dialog
        title="定位信息"
        v-model="dialogVisible"
        width="40%"
        :before-close="handleClose"
       
        >
        <div class="fuzzy-matching-box">
            <div class="fuzzy-matching-top">
                <el-row class="top-first-line the-second-line">
                    <el-col :span="6">
                    <el-form-item label="IMEI:">
                        <el-input v-model="Dform.imei" placeholder=''></el-input>
                    </el-form-item>
                    </el-col >
                    <el-col :span="6">
                        <el-form-item label="起始：">
                        <el-date-picker
                            v-model="Dform.started"
                            type="datetime"
                            format="YYYY-MM-DD HH:mm:ss"
                            value-format="YYYY-MM-DD HH:mm:ss"
                            placeholder="选择日期时间">
                        </el-date-picker>
                        </el-form-item>
                    </el-col >
                    <el-col :span="6">
                        <el-form-item label="截止：">
                        <el-date-picker
                            v-model="Dform.expirationTime"
                            type="datetime"
                            format="YYYY-MM-DD HH:mm:ss"
                            value-format="YYYY-MM-DD HH:mm:ss"
                            placeholder="选择日期时间">
                        </el-date-picker>
                        </el-form-item>
                    </el-col >
                    <el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
                    <!-- <el-col :span="5">
                    </el-col > -->
                    
            
                </el-row>
            </div>
    <div class="fuzzy-matching-bottom">
       <el-row class="list">
         <el-table
         :border="true"
         :header-cell-style="{background:'#EDF6FF',color:'#000',}"
          style="width: 100%"
           :data="tableData"
         >
          <el-table-column
            prop="imei"
            label="IMEI"
            >
          </el-table-column>
            <el-table-column
            prop="cause"
            label='过滤原因'
            >
          </el-table-column>
          <el-table-column
            prop="lng1"
            label="经度"
            >
          </el-table-column>
          <el-table-column
            prop="lat1"
            label="纬度"
            >
          </el-table-column>

          <el-table-column
            prop="type"
            label="取点数据类型"
            >
            <template #default="scope">
              <span  type="text"   v-if="scope.row.type == 1">GPS</span>
              <span  type="text"   v-if="scope.row.type == 2">LBS</span>
              <span  type="text"   v-if="scope.row.type == 3">LBS/CDMN</span>
              <span  type="text"   v-if="scope.row.type == 4">WIFI</span>

            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="上报时间"
            >
          </el-table-column>
          <el-table-column
            label="状态"
            >
            <template #default="scope">
              <span class="statusBtn" type="text"  v-if="scope.row.status == 0">待定点</span>
              <span class="statusBtn" type="text"  v-if="scope.row.status == 1">正常</span>
              <span class="statusBtn" type="text"  v-if="scope.row.status == 2">过滤点</span>
              <span class="statusBtn" type="text"  v-if="scope.row.status == 3">定位点</span>
              <span class="statusBtn" type="text"  v-if="scope.row.status == 4">纠错点</span>
              <span class="statusBtn" type="text"  v-if="scope.row.status == 6">守护点</span>

            </template>
          </el-table-column>
          <!-- <el-table-column
            label="操作"
            >
            <template #default="scope">
              <el-button class="shanchuBtn" type="text" size="small" @click="deleteClick(scope.row)" >删除</el-button>

            </template>
          </el-table-column> -->
          
        </el-table>
      </el-row>
      
      <div class="block-fenye" >
          <el-pagination
              :small="small"
              :disabled="disabled"
              :background="background"
              layout="prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
        </div>

    </div>


  </div>
        
    </el-dialog>
</template>
<script>
// import { ElMessage } from 'element-plus'
import {FindGpsInfo,DeleteGpsInfo,UpdateGpsInfo} from '@/assets/api/user'

export default {
    components: {
        
    },
    props: ['mapObj'],
    data() {

        return {
            dialogVisible: true,
            loading:false,
            Dform: {
             imei:'',
             started:'',
             expirationTime:'',
             },
             tableData:[],
             total:'',
             pageInfo: {
                page: 1,
                pageSize: 8,
            },
        }

    },
    created(){
       this.getFindGpsInfo()
       
    },
    mounted(){
     
    },
    methods:{
        getFindGpsInfo(){
            const params = {
                endTime:this.Dform.expirationTime,
                startTime:this.Dform.started,
                imei:this.Dform.imei != '' ?this.Dform.imei :this.mapObj.imei ,
                page:this.pageInfo.page,
                pageSize:this.Dform.pageSize,
                userId: JSON.parse(localStorage.getItem('user')).id,
            }
            FindGpsInfo(params).then((res) => {
                console.log(res.data.data.list,'11111111');
                this.tableData = res.data.data.list
                this.total =  res.data.data.total
            }).catch((err) => {
                console.log(err,'2222222');
            })

            },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageInfo.page = val
            this.getFindGpsInfo()
            },
        handleClose() {
            this.$emit('cMapClick')
      },
      entrylogClick(){
        this.getFindGpsInfo()
      }
    //   getMapInfo(){
    //         let params = {
    //             deviceId: this.mapObj.deviceId || null,
    //             imei:this.mapObj.imei,
    //             userId:this.mapObj.deviceId == '' ? null: JSON.parse(localStorage.getItem('user')).id
    //         }
    //         deviceDetails(params).then((res) => {
    //               this.MyData = res.data.data
    //               this.initMap(this.MyData) 
    //         }).catch((err)=> {
    //             console.log(err);
    //             this.$message({
    //                 type: 'error',
    //                 message: err.response.data.msg
    //             });

    //         })  
        
    //     },


      
    }
    }




</script>
<style  scoped lang="scss">
:deep() {
    .el-form-item--small .el-form-item__label {
        margin-left: 15px;
    }
    // .el-button--small{
    //     margin-left: 40px;
    // }
    .el-input--small .el-input__wrapper {
        height: 30px;
    }
}
.query-button{
    margin-left: 40px;

}
 
   
</style>